import { withTranslation } from "react-i18next";

let TranslatedTextComponent = ({textKey, t}) => {
	return t(textKey);
};

export default withTranslation() (TranslatedTextComponent)